import { getTheme } from 'office-ui-fabric-react';
import * as React from 'react';
import { Stack } from '../Stack';
import { SubHeading, SubHeadingLevel } from '../Typography/sub-heading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ModalLayout = _ref => {
  let {
    minWidth = 500,
    heading,
    content,
    buttons,
    critical = false
  } = _ref;
  const theme = getTheme();
  const containerStyles = {
    root: {
      minWidth: minWidth,
      border: critical ? "solid 2px ".concat(theme.palette.redDark) : ''
    }
  };
  const render = () => {
    return /*#__PURE__*/_jsxs(Stack, {
      tokens: {
        childrenGap: 10,
        padding: 10
      },
      styles: containerStyles,
      children: [/*#__PURE__*/_jsx(SubHeading, {
        headingLevel: SubHeadingLevel.Level1,
        children: heading
      }), content, buttons && renderButtons()]
    });
  };
  const renderButtons = () => {
    return /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: "end",
      tokens: {
        childrenGap: 10,
        padding: '10px 0 0 0'
      },
      children: buttons
    });
  };
  return render();
};